module.exports = __webpack_public_path__ + "img/partner_logo04.246b9fce.png";